// extracted by mini-css-extract-plugin
module.exports = {"modalitem":"L0XyVczbHWlT2k_YeLuV-"};